<template>
    <div>
        <BlogHeader :index = "''"></BlogHeader>
        <div style="margin: 40px 6% 0 6%;padding: 30px;">
            <el-row style="margin-bottom: 20px;">
                <el-col :span="17">
                    <el-card shadow="hover" class="article" v-loading="articleLoading">
                        <h1 style="border-left: 8px solid lightblue;">&nbsp;{{article.title}}</h1>
                        <hr>
                        <div>
                            <el-button size="mini" round>{{$t('publish')}}：{{article.addtime|handle_str(2)}}</el-button>
                            <el-button size="mini" round>{{$t('clicknum')}}：{{article.look}}</el-button>
                            <el-button-group style="float: right">
                                <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleSize(1)">N</el-button>
                                <el-button size="mini" type="primary" @click="handleSize(0)">N<i class="el-icon-minus el-icon--right"></i></el-button>
                                <el-button size="mini" type="primary" icon="el-icon-star-off" @click="addLove" v-if="!isLove">{{article.love}}</el-button>
                                <el-button size="mini" type="primary" icon="el-icon-star-on" @click="addLove" v-if="isLove">{{article.love}}</el-button>
                            </el-button-group>
                        </div>
                        <hr>
                        <div v-html="detail" class="content" v-bind:style="{fontSize:fontsize+'px'}"></div>
                    </el-card>

                    <el-card shadow="hover" class="comment" v-loading="articleLoading">

                        <div><i class="el-icon-edit"></i>{{$t('comment')}}</div><hr>
                        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" v-loading="submitLoading">
                            <el-form-item :label="$t('name')" prop="name">
                                <el-input :placeholder="$t('name_req')" prefix-icon="el-icon-edit" v-model="ruleForm.name"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('email')" prop="mail">
                                <el-input  :placeholder="$t('email_req')" prefix-icon="el-icon-edit" v-model="ruleForm.mail"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('comment_content')" prop="comment">
                                <el-input :placeholder="$t('follow')" prefix-icon="el-icon-edit" type="textarea" v-model="ruleForm.comment"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="submitForm('ruleForm')">{{$t('submit')}}</el-button>
                                <el-button size="small" @click="resetForm('ruleForm')">{{$t('reset')}}</el-button>
                            </el-form-item>
                        </el-form>
                        <div v-if="comment"><i class="el-icon-tickets"></i>{{$t('list')}}</div><hr v-if="comment">

                        <el-card shadow="hover" class="comment-index" v-for="(item,key) in commentList"  :key="item.pic" v-if="comment">
                            <el-collapse-transition>
                            <el-row>
                                <el-col :span="4"><img v-lazy="item.pic" :key="item.pic" style="width: 80px;height: 80px;"/></el-col>
                                <el-col :span="20">
                                    <el-row class="comment-name">{{item.username}}</el-row>
                                    <el-row class="comment-content">{{item.content}}</el-row>
                                    <el-row class="comment-time"><i class="el-icon-date"></i>&nbsp;{{item.add_time|handle_str(2)}}</el-row>
                                </el-col>
                            </el-row>
                            </el-collapse-transition>
                        </el-card>

                    </el-card>
                </el-col>

                <el-col :span="6" :offset="1">
                    <el-card shadow="hover" class="right-card">
                        <div slot="header">
                            <i class="el-icon-tickets"></i>{{$t('recommend')}}
                        </div>
                        <ul v-for="(item,key) in list" style="padding-left: 0px;">
                            <li>
                                <span>
                                    <span class="li-number" v-bind:style="{ background: key<3?'#AF441E':'gray' }">{{key+1}}</span>
                                    <a :href="'/#/detail/'+item.id">{{item.title}}</a>
                                </span>
                            </li>
                        </ul>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <BlogFoot></BlogFoot>
    </div>
</template>

<script>
    import BlogHeader from './common/BlogHeader.vue';
    import BlogFoot from './common/BlogFoot.vue';
    import common from '../config/common.js';
    export default {
        name: "Detail",
        data () {
            return {
                loading:true,
                articleLoading:true,
                isLove:false,
                comment:false,
                submitLoading:false,
                listLoading:false,
                article:[],
                list:[],
                commentList:[],
                detail:'',
                index1:'',
                index2:'',
                fontsize:15,
                id:'',
                ruleForm: {
                    name: '',
                    mail: '',
                    comment: '',
                },
                rules: {
                    name: [
                        { required: true, message: this.$t('name_r1'), trigger: 'blur' },
                        { min: 3, max: 15, message: this.$t('name_r2'), trigger: 'blur' }
                    ],
                    mail: [
                        { required: true, message: this.$t('email_r1'), trigger: 'blur' },
                        { type: 'email', message: this.$t('email_r2'), trigger: ['blur', 'change'] }
                    ],
                    comment: [
                        { required: true, message: this.$t('comment_r1'), trigger: 'blur' },
                        { min: 5, max: 50, message: this.$t('comment_r2'), trigger: 'blur' }

                    ]
                }
            }
        },components:{
            BlogFoot,
            BlogHeader
        },methods:{
            getDetail(id){
                this.isLove = this.$cookie.get('love'+id)?true:false;
                this.$axios.get(common.apiurl+'/api/detail/'+id).then((response)=>{
                    if(response.data.code==0){
                        this.article = response.data.data[0];
                        this.detail = response.data.data[0].detail.content;
                        this.$cookie.set('look'+id, '1', 1);
                        this.articleLoading = false;
                        this.getComment(id)
                    }
                    else {
                        this.$message({
                            message: this.$t('common.neterror'),
                            type: 'warning'
                        });
                    }
                }).catch((error)=>{
                    this.$message({
                        message: this.$t('common.neterror'),
                        type: 'warning'
                    });
                });
            },
            getRecommend(){
                this.$axios.get(common.apiurl+'/api/pc/list').then((response)=>{
                    if(response.data.code==0){
                        this.list = response.data.data;
                        this.listLoading = false;
                    }
                    else {
                        this.$message({
                            message: this.$t('common.neterror'),
                            type: 'warning'
                        });
                    }
                }).catch((error)=>{
                    this.$message({
                        message: this.$t('common.neterror'),
                        type: 'warning'
                    });
                });
            },
            addLook(id){
                if(this.$cookie.get('read'+id)){
                }else{
                    this.$axios.post(common.apiurl+'/api/inc/1/'+id).then((response)=>{
                        if(response.data.code==0){

                            this.article.look++;
                            this.$cookie.set('read'+id, 1, 1);
                            if(this.$cookie.get('look')){
                                var look = JSON.parse(this.$cookie.get('look'));
                                for(var o in look){
                                    if(look[o].id==id){
                                        this.$cookie.delete('look');
                                        break;
                                    }
                                }
                            }
                        }
                        else {
                            console.log(this.$t('common.neterror'));
                        }
                    }).catch((error)=>{
                        console.log(this.$t('common.neterror'));
                    });
                }
            },
            handleSize(type){
                if(type){
                    if(this.fontsize>26){
                        this.$message({
                            showClose: true,
                            message: this.$t('toobig'),
                            type: 'warning'
                        });
                        return false;
                    }
                    this.fontsize++;
                }else{
                    if(this.fontsize<9){
                        this.$message({
                            showClose: true,
                            message:this.$t('toosmall'),
                            type: 'warning'
                        });
                        return false;
                    }
                    this.fontsize--;
                }
            },
            addLove(){
                if(this.$cookie.get('love'+this.id)){
                    this.$message({
                        message: this.$t('common.zaned'),
                        type: 'warning'
                    });
                }else{
                    this.$axios.post(common.apiurl+'/api/inc/2/'+this.id).then((response)=>{
                        if(response.data.code==0){
                            this.article.love++;
                            this.$cookie.set('love'+this.id,1,1);
                            this.$message({
                                message: this.$t('common.zan'),
                                type: 'success'
                            });
                            this.isLove = true;
                        }
                        else {
                            console.log(this.$t('common.neterror'));
                        }
                    }).catch((error)=>{
                        console.log(this.$t('common.neterror'));
                    });
                }
            },submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.submitLoading = true;
                        this.$axios.post(common.apiurl+'/api/comment','user='+this.$refs[formName].model.name+'&id='+this.id+'&email='+this.$refs[formName].model.mail+'&content='+this.$refs[formName].model.comment).then((response)=>{
                            this.submitLoading = false;
                            if(response.data.code==0){
                                this.$message({
                                    showClose: true,
                                    message: this.$t('detail_ok'),
                                    type: 'success'
                                });
                                this.comment = true;
                                this.commentList = [response.data.data].concat(this.commentList);
                                this.submitLoading = false;
                                this.$refs[formName].resetFields();
                            }
                            else {
                                if(response.data.msg)this.$message({
                                    showClose: true,
                                    message: response.data.msg,
                                    type: 'warning'
                                });
                                else this.$message({
                                    showClose: true,
                                    message: this.$t('detail_fail'),
                                    type: 'warning'
                                });

                            }
                        }).catch((error)=>{
                            this.submitLoading = false;
                            this.$message({
                                showClose: true,
                                message: this.$t('common.neterror'),
                                type: 'warning'
                            });
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: this.$t('noempty'),
                            type: 'warning'
                        });
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },getComment(id){
                this.$axios.get(common.apiurl+'/api/comment/'+id).then((response)=>{
                    if(response.data.code==0){
                        this.commentList = response.data.data;
                        if(this.commentList.length>0)this.comment = true;
                    }
                }).catch((error)=>{
                    console.log(this.$t('common.neterror'));
                });
            }
        },created:function () {
            window.scrollTo(0,0);
            this.id = this.$route.params.id;
            this.getDetail(this.id);
            this.addLook(this.id);
            this.getRecommend();

        },watch:{
            '$route' (to, from) {
                window.scrollTo(0,0);
                this.id = this.$route.params.id;
                this.getDetail(this.id);
                this.addLook(this.id);
                this.getRecommend();
            }
        }
    }
</script>

<style scoped>
    .article h1{
        font-size: 24px;
    }
    .content{
        min-height: 500px;
    }
    .comment{
        margin-top: 40px;
    }
    .comment-name{
        margin-bottom: 10px;
    }
    .comment-content{
        margin-left:20px;
        margin-bottom: 10px;
        color: #666;
    }
    .comment-time{
        text-align: right;
        color: #666;
        font-size: 14px;
    }
    .right-card >>> .el-card__header{
        background-color: #F7F7F7;
    }
    ul li{
        width: 99%;
        line-height: 28px;
        white-space: nowrap;
        word-wrap: normal;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-bottom: 5px;
    }
    .li-number{
        float: left;
        font-size: 12px;
        color: #fff;
        line-height: 150%;
        margin: 4px 5px 0 0;
        padding: 0 5px;
        border-radius: 2px;
    }
    li a{
        color: #555;
        text-decoration:none;
    }
</style>


// WEBPACK FOOTER //
// src/components/Detail.vue